import { useMemo } from 'react';

import ContentCard from 'approot/shared/content-card/content-card';
import {
  getStimulusExtraInfo,
  getStimulusResourceLink,
  getStimulusViewDataTrackingAttributes,
  sortAndDeduplicateStimulus,
} from 'approot/shared/stimulus/stimulus.utils';
import { contentTypeLabel } from 'approot/shared/logic/content-type-label';
import { STIMULUS_RATIO } from 'approot/shared/content-card/content-card.constants';
import {
  ContentCardCol,
  ContentCardRow,
} from 'approot/shared/content/content-row.style';
import { grey4 } from 'approot/shared/styles/colours.style';
import { StimulusResource } from './__generated__/StimulusResource';

type Props = {
  stimulus: {
    id: number;
    stimulusResources: StimulusResource[];
  };
};

const StimulusGuest = ({ stimulus }: Props) => {
  const sortedData = useMemo(
    () => sortAndDeduplicateStimulus(stimulus.stimulusResources),
    [stimulus.stimulusResources]
  );

  if (!stimulus.stimulusResources || stimulus.stimulusResources.length === 0)
    return null;

  return (
    <div data-selector="stimulus">
      <ContentCardRow>
        {sortedData.map(content => {
          const dataEventProps = getStimulusViewDataTrackingAttributes(content);

          const link = getStimulusResourceLink(content);

          return (
            <ContentCardCol key={`stimulus-${content.id}`}>
              <ContentCard
                {...dataEventProps}
                isEditable={false}
                isAlwaysViewable={false}
                ignoreImageOrientation
                detail={getStimulusExtraInfo(content)}
                title={content.name || ''}
                imageRatio={STIMULUS_RATIO}
                images={content.coverImage?.responsive || []}
                link={link}
                slug={content.slug || undefined}
                pillText={contentTypeLabel(content.type)}
                pillIcon={content.type}
                type={content.type}
                contentColour={grey4}
              />
            </ContentCardCol>
          );
        })}
      </ContentCardRow>
    </div>
  );
};

export default StimulusGuest;
